import { render, staticRenderFns } from "./scanPay.vue?vue&type=template&id=5097c2ca&scoped=true&"
import script from "./scanPay.vue?vue&type=script&lang=js&"
export * from "./scanPay.vue?vue&type=script&lang=js&"
import style0 from "./scanPay.vue?vue&type=style&index=0&id=5097c2ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5097c2ca",
  null
  
)

export default component.exports